import {Color, colors} from '@mui/material';
import {DatabaseMetadataEstado} from './enums';
import palette from 'src/theme/palette';

export class DatabaseMetadataEstadoUtils {
   static getColor(
      estado: string
   ): {
      main: string;
      dark: string;
      light: string;
   } {
      const main:string = colors.grey[500];
      const dark:string = colors.grey[700];
      const light:string = colors.grey[300];

      let color: {main:string, dark:string, light:string} = { main, dark, light };
      switch (estado) {
         case DatabaseMetadataEstado.OK:
            color = palette.success;
            break;
         case DatabaseMetadataEstado.HUERFANA:
            color = palette.warning;
            break;
         case DatabaseMetadataEstado.FANTASMA:
            color = palette.info;
            break;
         case DatabaseMetadataEstado.EXPIRADA:
            color = palette.error;
            break;
      }
      return color;
      ;
   }
   static getDescription(estado: string) {
      switch (estado) {
         case DatabaseMetadataEstado.OK:
            return 'OK';
         case DatabaseMetadataEstado.HUERFANA:
            return 'Base de datos existe, pero no tiene relaciones en manager.';
         case DatabaseMetadataEstado.FANTASMA:
            return 'Existen relaciones en manager pero la base de datos no existe.';
         case DatabaseMetadataEstado.EXPIRADA:
            return 'Las cuentas relacionadas con la base de datos tienen un plan vencido.';
         default:
            return 'Estado desconocido';
      }
   }
}
